module.exports = __webpack_public_path__ + "img/border_two_lineWhite.f9ca1169.svg";